/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/trsonline/components/add-to-cart/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("m4hc");


/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "MTIv":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__("mJPh");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "PGo9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("RtT2");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js??ref--2-3!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./add-to-cart.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js??ref--2-3!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./add-to-cart.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RtT2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".add-to-cart-component:only-child{width:100%}.add-to-cart-component__action-btn{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;width:50%;padding:12px 8px;margin:0;border:none;vertical-align:middle;font-weight:500;text-align:center;outline:none}.add-to-cart-component__action-btn:only-child{width:100%}.add-to-cart-component__action-btn-icon:before{text-align:center;color:#fff;font-size:16px;font-family:Font Awesome\\ 5 Free;font-weight:900}.add-to-cart-component__action-btn-text{position:relative;z-index:5;display:inline-block;opacity:1;-webkit-transition:opacity .35s ease;transition:opacity .35s ease}.add-to-cart-component__action-btn--add:disabled:not(.add-to-cart-component__action-btn--success):not(.add-to-cart-component__action-btn--error){background-color:#d6d6d6}.add-to-cart-component__action-btn--add{background-color:#f7991c;font-size:14px;text-transform:uppercase;-webkit-transition:background-color .2s ease,-webkit-box-shadow .2s ease;transition:background-color .2s ease,-webkit-box-shadow .2s ease;transition:box-shadow .2s ease,background-color .2s ease;transition:box-shadow .2s ease,background-color .2s ease,-webkit-box-shadow .2s ease}.add-to-cart-component__action-btn--add:not(:only-child){border-left:1px solid #d6d6d6}.add-to-cart-component__action-btn--add .add-to-cart-component__action-btn-icon{position:absolute;display:none;top:0;bottom:0;left:0;width:100%}.add-to-cart-component__action-btn--add .add-to-cart-component__action-btn-icon>i{display:inline-block;position:absolute;top:50%;left:50%;vertical-align:center;font-size:16px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transition:opacity .25s linear;transition:opacity .25s linear;-webkit-animation:spinnerSpin 1.5s linear infinite;animation:spinnerSpin 1.5s linear infinite}@-webkit-keyframes spinnerSpin{0%{-webkit-transform:translate(-50%,-50%) rotate(0deg);transform:translate(-50%,-50%) rotate(0deg)}to{-webkit-transform:translate(-50%,-50%) rotate(1turn);transform:translate(-50%,-50%) rotate(1turn)}}@keyframes spinnerSpin{0%{-webkit-transform:translate(-50%,-50%) rotate(0deg);transform:translate(-50%,-50%) rotate(0deg)}to{-webkit-transform:translate(-50%,-50%) rotate(1turn);transform:translate(-50%,-50%) rotate(1turn)}}.add-to-cart-component__action-btn--add .add-to-cart-component__action-btn-icon:before{content:\"\";position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.add-to-cart-component__action-btn--add:hover:not(:disabled){background-color:#f18d08}.add-to-cart-component__action-btn--loading{background-color:#d6d6d6}.add-to-cart-component__action-btn--loading .add-to-cart-component__action-btn-text{opacity:0}.add-to-cart-component__action-btn--loading .add-to-cart-component__action-btn-icon{display:block}.add-to-cart-component__action-btn--loading .add-to-cart-component__svg-ok{display:none;visibility:hidden}.add-to-cart-component__action-btn--loading:hover{cursor:not-allowed;background-color:#d6d6d6}.add-to-cart-component__action-btn--success{background-color:#0cae5b}.add-to-cart-component__action-btn--success .add-to-cart-component__action-btn-text{opacity:0}.add-to-cart-component__action-btn--success .add-to-cart-component__action-btn-icon{display:block}.add-to-cart-component__action-btn--success .add-to-cart-component__action-btn-icon>i{display:none}.add-to-cart-component__action-btn--success .add-to-cart-component__action-btn-icon:before{content:\"\\F00C\"}.add-to-cart-component__action-btn--success:hover{cursor:not-allowed;background-color:#0cae5b}.add-to-cart-component__action-btn--error{background-color:#c91d1d}.add-to-cart-component__action-btn--error .add-to-cart-component__action-btn-text{opacity:0}.add-to-cart-component__action-btn--error .add-to-cart-component__action-btn-icon{display:block}.add-to-cart-component__action-btn--error .add-to-cart-component__action-btn-icon>i{display:none}.add-to-cart-component__action-btn--error .add-to-cart-component__action-btn-icon:before{content:\"\\F00D\"}.add-to-cart-component__action-btn--error:hover{cursor:not-allowed;background-color:#c91d1d}", ""]);

// exports


/***/ }),

/***/ "Y/mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SVGNamespace */
/* unused harmony export preventDefault */
/* unused harmony export stopPropagation */
/* unused harmony export Fragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createElement; });
/* unused harmony export createElement */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//https://github.com/glixlur/jsx-dom

var __assign = Object.assign;

var keys = Object.keys;
function isBoolean(val) {
    return typeof val === "boolean";
}
function isElement(val) {
    return val && typeof val.nodeType === "number";
}
function isString(val) {
    return typeof val === "string";
}
function isNumber(val) {
    return typeof val === "number";
}
function isObject(val) {
    return (typeof val === "undefined" ? "undefined" : _typeof(val)) === "object" ? val !== null : isFunction(val);
}
// tslint:disable-next-line:ban-types
function isFunction(val) {
    return typeof val === "function";
}
function isArrayLike(obj) {
    return isObject(obj) && typeof obj.length === "number" && typeof obj.nodeType !== "number";
}

var SVGNamespace = "http://www.w3.org/2000/svg";
var XLinkNamespace = "http://www.w3.org/1999/xlink";
var XMLNamespace = "http://www.w3.org/XML/1998/namespace";
function preventDefault(event) {
    event.preventDefault();
    return event;
}
function stopPropagation(event) {
    event.stopPropagation();
    return event;
}
// https://facebook.github.io/react/docs/jsx-in-depth.html#booleans-null-and-undefined-are-ignored
// Emulate JSX Expression logic to ignore certain type of children or className.
function isVisibleChild(value) {
    return !isBoolean(value) && value !== null;
}
/**
 * Convert a `value` to a className string.
 * `value` can be a string, an array or a `Dictionary<boolean>`.
 */
function className(value) {
    if (Array.isArray(value)) {
        return value.map(className).filter(Boolean).join(" ");
    } else if (isObject(value)) {
        return keys(value).filter(function (k) {
            return value[k];
        }).join(" ");
    } else if (isVisibleChild(value)) {
        return "" + value;
    } else {
        return "";
    }
}
var svg = {
    animate: 0,
    circle: 0,
    clipPath: 0,
    defs: 0,
    desc: 0,
    ellipse: 0,
    feBlend: 0,
    feColorMatrix: 0,
    feComponentTransfer: 0,
    feComposite: 0,
    feConvolveMatrix: 0,
    feDiffuseLighting: 0,
    feDisplacementMap: 0,
    feDistantLight: 0,
    feFlood: 0,
    feFuncA: 0,
    feFuncB: 0,
    feFuncG: 0,
    feFuncR: 0,
    feGaussianBlur: 0,
    feImage: 0,
    feMerge: 0,
    feMergeNode: 0,
    feMorphology: 0,
    feOffset: 0,
    fePointLight: 0,
    feSpecularLighting: 0,
    feSpotLight: 0,
    feTile: 0,
    feTurbulence: 0,
    filter: 0,
    foreignObject: 0,
    g: 0,
    image: 0,
    line: 0,
    linearGradient: 0,
    marker: 0,
    mask: 0,
    metadata: 0,
    path: 0,
    pattern: 0,
    polygon: 0,
    polyline: 0,
    radialGradient: 0,
    rect: 0,
    stop: 0,
    svg: 0,
    switch: 0,
    symbol: 0,
    text: 0,
    textPath: 0,
    tspan: 0,
    use: 0,
    view: 0
};
function Fragment(attr) {
    var fragment = document.createDocumentFragment();
    appendChildren(attr.children, fragment);
    return fragment;
}
function createElement(tag, attr) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    attr = attr || {};
    if (!attr.namespaceURI && svg[tag] === 0) {
        attr = __assign({}, attr, { namespaceURI: SVGNamespace });
    }
    var node;
    if (isString(tag)) {
        node = attr.namespaceURI ? document.createElementNS(attr.namespaceURI, tag) : document.createElement(tag);
        attributes(attr, node);
        appendChildren(children, node);
    } else if (isFunction(tag)) {
        // Custom elements.
        node = tag(__assign({}, attr, { children: children }));
    }
    if (isFunction(attr.ref)) {
        attr.ref(node);
    }
    return node;
}
function appendChild(child, node) {
    if (isArrayLike(child)) {
        appendChildren(child, node);
    } else if (isString(child) || isNumber(child)) {
        node.appendChild(document.createTextNode(child));
    } else if (child === null) {
        node.appendChild(document.createComment(""));
    } else if (isElement(child)) {
        node.appendChild(child);
    }
}
function appendChildren(children, node) {
    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
        var child = children_1[_i];
        appendChild(child, node);
    }
    return node;
}
function normalizeAttribute(s) {
    return s.replace(/[A-Z\d]/g, function (match) {
        return ":" + match.toLowerCase();
    });
}
function attribute(key, value, node) {
    {
        switch (key) {
            case "xlinkActuate":
            case "xlinkArcrole":
            case "xlinkHref":
            case "xlinkRole":
            case "xlinkShow":
            case "xlinkTitle":
            case "xlinkType":
                node.setAttributeNS(XLinkNamespace, normalizeAttribute(key), value);
                return;
            case "xmlnsXlink":
                node.setAttribute(normalizeAttribute(key), value);
                return;
            case "xmlBase":
            case "xmlLang":
            case "xmlSpace":
                node.setAttributeNS(XMLNamespace, normalizeAttribute(key), value);
                return;
        }
    }
    switch (key) {
        case "dataset":
            for (var _i = 0, _a = keys(value || {}); _i < _a.length; _i++) {
                var dataKey = _a[_i];
                var dataValue = value[dataKey];
                if (dataValue !== null) {
                    node.dataset[dataKey] = dataValue;
                }
            }
            return;
        case "innerHTML":
        case "innerText":
        case "textContent":
            node[key] = value;
            return;
        case "spellCheck":
            node.spellcheck = value;
            return;
        case "class":
        case "className":
            node.setAttribute("class", className(value));
            return;
        case "ref":
        case "namespaceURI":
            return;
        case "style":
            if (isObject(value)) {
                __assign(node.style, value);
                return;
            }
    }
    if (isFunction(value)) {
        if (key[0] === "o" && key[1] === "n") {
            var name = key.slice(2).toLowerCase();
            listen(node, name, value);
        }
    } else if (value === true) {
        node.setAttribute(key, "");
    } else if (value !== false && value !== null) {
        node.setAttribute(key, value);
    }
}
function attributes(attr, node) {
    for (var _i = 0, _a = keys(attr); _i < _a.length; _i++) {
        var key = _a[_i];
        attribute(key, attr[key], node);
    }
    return node;
}
function listen(node, eventName, callback) {
    node.addEventListener(eventName, callback);
    return node;
}



/***/ }),

/***/ "m4hc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_jsx_dom_svg_js__ = __webpack_require__("Y/mi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_to_cart_scss__ = __webpack_require__("PGo9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_to_cart_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__add_to_cart_scss__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TAG = "add-to-cart";

var VALUE_ATTRIBUTE_NOT_PRESENT = null;

var AddToCart = function (_HTMLElement) {
    _inherits(AddToCart, _HTMLElement);

    _createClass(AddToCart, [{
        key: "disabled",
        get: function get() {
            return this._isDisabled;
        },
        set: function set(flag) {
            if (typeof flag !== "boolean") {
                throw "'disabled' property only accepts boolean value, instead " + (typeof flag === "undefined" ? "undefined" : _typeof(flag)) + " is passed in.";
            }

            if (flag) {
                this.setAttribute("disabled", "");
            } else {
                this.removeAttribute("disabled");
            }
        }
    }], [{
        key: "observedAttributes",
        get: function get() {
            return ["disabled"];
        }
    }]);

    function AddToCart() {
        var _this2 = this;

        _classCallCheck(this, AddToCart);

        var _this = _possibleConstructorReturn(this, (AddToCart.__proto__ || Object.getPrototypeOf(AddToCart)).call(this));

        Object.defineProperty(_this, "_isDisabled", {
            enumerable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_initInternalDoms", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this._eleButton = Object(__WEBPACK_IMPORTED_MODULE_0__common_jsx_dom_svg_js__["a" /* h */])(
                    "button",
                    {
                        "class": "add-to-cart-component__action-btn add-to-cart-component__action-btn--add add-to-cart-component__action-btn--add-js",
                        onClick: _this._onAddToCartClicked
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_0__common_jsx_dom_svg_js__["a" /* h */])(
                        "span",
                        { "class": "add-to-cart-component__action-btn-icon" },
                        Object(__WEBPACK_IMPORTED_MODULE_0__common_jsx_dom_svg_js__["a" /* h */])("i", { "class": "fas fa-circle-notch" })
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0__common_jsx_dom_svg_js__["a" /* h */])("span", {
                        "class": "add-to-cart-component__action-btn-text",
                        ref: function ref(r) {
                            return _this._eleContentHolder = r;
                        }
                    })
                );
            }
        });
        Object.defineProperty(_this, "_setDisableState", {
            enumerable: true,
            writable: true,
            value: function value(newState) {
                //set internal state property
                _this._isDisabled = newState;

                //update internal button state
                _this._eleButton.disabled = _this._isDisabled;
            }
        });
        Object.defineProperty(_this, "_moveContent", {
            enumerable: true,
            writable: true,
            value: function value() {
                while (_this.childNodes.length > 0) {
                    _this._eleContentHolder.appendChild(_this.childNodes[0]);
                }
            }
        });
        Object.defineProperty(_this, "_addForTrade", {
            enumerable: true,
            writable: true,
            value: function value(_ref) {
                var productNumber = _ref.productNumber,
                    productName = _ref.productName,
                    quantity = _ref.quantity,
                    cmpGstInclusivePrice = _ref.cmpGstInclusivePrice,
                    gstInclusivePrice = _ref.gstInclusivePrice,
                    unit = _ref.unit,
                    unitOfMeasure1 = _ref.unitOfMeasure1,
                    unitOfMeasure2 = _ref.unitOfMeasure2;

                return new Promise(function (resolve, reject) {
                    try {
                        setTimeout(function () {
                            window.Widget.addToList({
                                productNumber: productNumber,
                                productName: productName,
                                quantity: quantity,
                                cmpGstInclusivePrice: cmpGstInclusivePrice,
                                gstInclusivePrice: gstInclusivePrice,
                                unit: unit,
                                unitOfMeasure1: unitOfMeasure1,
                                unitOfMeasure2: unitOfMeasure2
                            });
                            resolve();
                        }, 500);
                    } catch (e) {
                        reject();
                    }
                });
            }
        });
        Object.defineProperty(_this, "_addForRetail", {
            enumerable: true,
            writable: true,
            value: function value(_ref2) {
                var productNumber = _ref2.productNumber,
                    quantity = _ref2.quantity,
                    quoteId = _ref2.quoteId,
                    lineId = _ref2.lineId,
                    unit = _ref2.unit;

                return new Promise(function (resolve, reject) {
                    window.CART.fn.addItems({
                        addItems: [{
                            productCode: productNumber,
                            quantity: quantity,
                            quoteId: quoteId,
                            pack: unit,
                            lineId: lineId
                        }]
                    }, quoteId, resolve, reject);
                });
            }
        });
        Object.defineProperty(_this, "_onAddToCartClicked", {
            enumerable: true,
            writable: true,
            value: function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var userType, promiseOp;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _this._eleButton.classList.add("add-to-cart-component__action-btn--loading");

                                    _this.disabled = true;

                                    userType = _this.getAttribute("user-type");
                                    promiseOp = null;


                                    if (userType == "max") {
                                        promiseOp = _this._addForTrade(_this.dataset);
                                    } else {
                                        promiseOp = _this._addForRetail(_this.dataset);
                                    }

                                    promiseOp.then(_this._onSuccessCallback).catch(_this._onFailCallback).then(_this._removeAllStatusClasses).catch(_this._removeAllStatusClasses);

                                case 6:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }));

                return function value() {
                    return _ref3.apply(this, arguments);
                };
            }()
        });
        Object.defineProperty(_this, "_removeAllStatusClasses", {
            enumerable: true,
            writable: true,
            value: function value() {
                setTimeout(function () {
                    _this.disabled = false;

                    _this._eleButton.classList.remove("add-to-cart-component__action-btn--success");
                    _this._eleButton.classList.remove("add-to-cart-component__action-btn--error");
                    _this._eleButton.classList.remove("add-to-cart-component__action-btn--loading");
                }, 1500);
            }
        });
        Object.defineProperty(_this, "_onSuccessCallback", {
            enumerable: true,
            writable: true,
            value: function value() {
                _this._eleButton.classList.add("add-to-cart-component__action-btn--success");
                _this.dispatchEvent(new CustomEvent("add-to-cart__add-success", {
                    detail: {
                        success: true
                    }
                }));
            }
        });
        Object.defineProperty(_this, "_onFailCallback", {
            enumerable: true,
            writable: true,
            value: function value(e) {
                _this._eleButton.classList.add("add-to-cart-component__action-btn--error");
                _this.dispatchEvent(new CustomEvent("add-to-cart__add-fail", {
                    detail: {
                        success: true,
                        error: e.message
                    }
                }));
            }
        });

        _this._isLoading = false;
        _this._initInternalDoms();
        return _this;
    }

    _createClass(AddToCart, [{
        key: "connectedCallback",
        value: function connectedCallback() {
            this._moveContent();
            this.appendChild(this._eleButton);
            this.classList.add("add-to-cart-component");
        }
    }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, oldValue, newValue) {
            if (name == "disabled" && oldValue !== newValue) {
                var shouldDisable = newValue !== VALUE_ATTRIBUTE_NOT_PRESENT;
                this._setDisableState(shouldDisable);
            }
        }
    }]);

    return AddToCart;
}(HTMLElement);

customElements.define(TAG, AddToCart);

/***/ }),

/***/ "mJPh":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// static/js/add-to-cart.js